import type { LoaderFunction, LinksFunction, MetaFunction } from 'react-router'
import { ErrorWrapper } from '~/components/ErrorWrapper'

import { data } from 'react-router'

import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
  useLocation,
} from 'react-router'
import { useEffect } from 'react'
import * as gtag from '~/utils/gtags.client'

import '~/styles/tailwind.css'

type LoaderData = {
  gaTrackingId: string | undefined
}

// Load the GA tracking id from the .env
export const loader: LoaderFunction = async () => {
  return data({ gaTrackingId: process.env.GA_TRACKING_ID })
}

export const links: LinksFunction = () => {
  return [
    { rel: 'icon', href: '/images/favicon.ico' },
  ]
}

export const meta: MetaFunction = () => ([
  { charset: 'utf-8' },
  { title: 'Organ Donor Registry' },
  { name: 'viewport', content: 'width=device-width,initial-scale=1' },
])

export function ErrorBoundary({ error }: { error: Error }) {
  return <ErrorWrapper error={error} />
}

export default function App() {
  const location = useLocation()
  const { gaTrackingId } = useLoaderData<LoaderData>()

  useEffect(() => {
    if (gaTrackingId?.length) {
      gtag.pageview(location.pathname, gaTrackingId)
    }
  }, [location, gaTrackingId])

  return (
    <html lang="en" className="h-full">
      <head>
        <Meta />
        <Links />
      </head>
      <body className="container mx-auto max-w-[1440px] bg-[#fafafa] pt-0 print:text-sm">
        {process.env.NODE_ENV === 'development' || !gaTrackingId ? null : (
          <>
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`} />
            <script
              async
              id="gtag-init"
              dangerouslySetInnerHTML={{
                __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${gaTrackingId}');
            `,
              }}
            />
          </>
        )}
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}
